// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-2TgAr";
var _3 = "breadcrumb-3BdqW";
var _4 = "leftBlock-35GUe";
var _5 = "icon-3Z5Ec";
var _6 = "content-2Ywg0";
var _7 = "label-3lWIM";
var _8 = "description-R1mzh";
var _9 = "closeButton-2vuXv";
export { _1 as "__esModule", _2 as "root", _3 as "breadcrumb", _4 as "leftBlock", _5 as "icon", _6 as "content", _7 as "label", _8 as "description", _9 as "closeButton" }
export default { "__esModule": _1, "root": _2, "breadcrumb": _3, "leftBlock": _4, "icon": _5, "content": _6, "label": _7, "description": _8, "closeButton": _9 }
